import { useSelector } from 'react-redux'
import { css } from '@emotion/react'
import { selectOnboardingLayoutVariant } from '../selectors'

const style = () => theme => css`
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: ${theme.spacing['16']} !important;
  color: ${theme.color.monochrome.black};
  font-weight: ${theme.fontWeight.normal};
  strong {
    font-weight: ${theme.fontWeight.semiBold};
  }
`

const PageHeader = ({ children }) => {
  const layoutVariant = useSelector(selectOnboardingLayoutVariant)
  return (
    <p
      css={[style]}
      className={layoutVariant === 3 && 'Onboarding_PageHeader-v3'}
    >
      {children || (
        <>
          Join 2,000+ small businesses using Groove to streamline their customer
          support.
          {/* <br />
          <strong>100% free, no credit card required.</strong> */}
        </>
      )}
    </p>
  )
}

export default PageHeader
